import { colors } from '@keen.io/colors';
import { getFromPath, calculateTotalValue, formatValue as valueFormatter, } from '@keen.io/charts-utils';
import { OTHERS_DATA_KEY } from '../constants';
export var getCircularChartTooltipContent = function (_a) {
    var data = _a.data, keys = _a.keys, labelSelector = _a.labelSelector, selectors = _a.selectors, _b = _a.disabledLabels, disabledLabels = _b === void 0 ? [] : _b, formatValue = _a.formatValue, valueMode = _a.valueMode;
    var content = [];
    var isPercentageMode = valueMode === 'percentage';
    selectors.length > 1 &&
        content.push({ color: colors.gray[500], data: OTHERS_DATA_KEY });
    var filteredData = data.filter(function (el) { return !disabledLabels.includes(el[labelSelector]); });
    var allValuesTotal = calculateTotalValue(filteredData, labelSelector, keys);
    selectors.forEach(function (_a) {
        var selector = _a.selector, color = _a.color;
        var item = getFromPath(data, selector);
        var total = keys.reduce(function (acc, keyName) {
            return acc + item[keyName];
        }, 0);
        var formattedTotal = valueFormatter(total, formatValue);
        var valuePercent = String((Math.round(total * 100) / allValuesTotal).toFixed(1) + "%");
        var value = isPercentageMode ? valuePercent : "" + formattedTotal;
        var label = item[labelSelector];
        var change = isPercentageMode
            ? "(" + formattedTotal + ")"
            : "(" + valuePercent + ")";
        var newColor = color;
        if (selectors.length > 1) {
            label = item[labelSelector];
            newColor = 'rgba(0, 0, 0, 0)';
        }
        content.push({
            color: newColor,
            data: {
                label: label,
                value: value,
                change: change,
            },
        });
    });
    return content;
};
